import { timesIcon } from "../../../elements/icons/index.js";
import button from "@foretagsplatsen/finsit-design-system/widget-js/elements/button";
import inputFieldWidget from "./inputFieldWidget.js";

/**
 * Input to select a color. It offers both a text field and a native color
 * picker.
 *
 * @param {bool} [resettable] - When true, a reset button is displayed at
 *   the end of the line. Clicking it resets the value to `null`
 * @param {string} [defaultColor] - The color that will be displayed
 *   if the accessor cannot get a truthy value, and when the input is
 *   reset
 */
function colorPickerFieldWidget(spec, my) {
	spec ||= {};
	my ||= {};

	const that = inputFieldWidget(spec, my);

	my.renderInputFieldOn = function (html) {
		const color = that.getValue() || spec.defaultColor;
		let input;
		let picker;

		html.div(
			{ class: "colorPickerFieldWidget" },
			(html) => {
				input = html.input({
					klass: spec.klass || "form-control",
					type: spec.type || "text",
					name: spec.name || spec.attribute,
					value: color || "",
					autocomplete: my.autocomplete ? "on" : "off",
					placeHolder: spec.placeHolder || " ",
				});
			},
			(html) => {
				picker = html.input({
					type: "color",
					klass: "form-control color-picker",
					value: color || "#ffffff",
					name: `picker-${spec.name || spec.attribute}`,
				});
			},
			my.renderResetButtonOn.bind(my),
		);

		input.on("input", () => {
			my.updateValue(true);
			that.trigger("input");
		});

		picker.on("input", () => my.field.asJQuery().val(picker.element.value));
		picker.on("change", () => my.updateValue());

		return input;
	};

	my.registerChangeOnBlur = function () {
		// do nothing
	};

	my.renderResetButtonOn = function (html) {
		if (!spec.resettable) {
			return;
		}

		html.render(
			button(
				{
					as: "span",
					dataTest: "reset",
					onClick: () => {
						that.setValue(null);
					},
				},
				timesIcon,
			),
		);
	};

	return that;
}

export default colorPickerFieldWidget;
